import React, {useEffect, useState} from "../../_snowpack/pkg/react.js";
import {useTranslation} from "../../_snowpack/pkg/react-i18next.js";
import {useForm} from "../../_snowpack/pkg/react-hook-form.js";
import {
  ActionGroup,
  AlertVariant,
  Button,
  ButtonVariant,
  Form,
  FormGroup,
  Modal,
  ModalVariant,
  TextInput,
  ValidatedOptions
} from "../../_snowpack/pkg/@patternfly/react-core.js";
import {CogIcon, TrashIcon} from "../../_snowpack/pkg/@patternfly/react-icons.js";
import {useAdminClient, useFetch} from "../../context/auth/AdminClient.js";
import {useAlerts} from "../../components/alert/Alerts.js";
import {HelpItem} from "../../components/help-enabler/HelpItem.js";
export const ExecutionConfigModal = ({
  execution
}) => {
  const {t} = useTranslation("authentication");
  const adminClient = useAdminClient();
  const {addAlert, addError} = useAlerts();
  const [show, setShow] = useState(false);
  const [config, setConfig] = useState();
  const [configDescription, setConfigDescription] = useState();
  const {register, errors, setValue, handleSubmit} = useForm();
  const setupForm = (configDescription2, config2) => {
    configDescription2.properties.map((property) => {
      setValue(property.name, config2?.config?.[property.name] || property.defaultValue || "");
    });
    if (config2) {
      setValue("alias", config2.alias);
      setValue("id", config2.id);
    }
  };
  useFetch(async () => {
    const configDescription2 = await adminClient.authenticationManagement.getConfigDescription({
      providerId: execution.providerId
    });
    let config2;
    if (execution.authenticationConfig) {
      config2 = await adminClient.authenticationManagement.getConfig({
        id: execution.authenticationConfig
      });
    }
    return {configDescription: configDescription2, config: config2};
  }, ({configDescription: configDescription2, config: config2}) => {
    setConfigDescription(configDescription2);
    setConfig(config2);
  }, []);
  useEffect(() => {
    if (configDescription)
      setupForm(configDescription, config);
  }, [show]);
  const save = async (changedConfig) => {
    try {
      if (config) {
        const newConfig = {
          ...config,
          config: changedConfig
        };
        await adminClient.authenticationManagement.updateConfig(newConfig);
        setConfig(newConfig);
      } else {
        const newConfig = {
          id: execution.id,
          alias: changedConfig.alias,
          config: changedConfig
        };
        const {id} = await adminClient.authenticationManagement.createConfig(newConfig);
        setConfig({...newConfig, id});
      }
      addAlert(t("configSaveSuccess"), AlertVariant.success);
      setShow(false);
    } catch (error) {
      addError("authentication:configSaveError", error);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    variant: "plain",
    "aria-label": t("common:settings"),
    onClick: () => setShow(true)
  }, /* @__PURE__ */ React.createElement(CogIcon, null)), configDescription && /* @__PURE__ */ React.createElement(Modal, {
    variant: ModalVariant.small,
    isOpen: show,
    title: t("executionConfig", {name: configDescription.name}),
    onClose: () => setShow(false)
  }, /* @__PURE__ */ React.createElement(Form, {
    id: "execution-config-form",
    onSubmit: handleSubmit(save)
  }, /* @__PURE__ */ React.createElement(FormGroup, {
    label: t("alias"),
    fieldId: "alias",
    helperTextInvalid: t("common:required"),
    validated: errors.alias ? ValidatedOptions.error : ValidatedOptions.default,
    isRequired: true,
    labelIcon: /* @__PURE__ */ React.createElement(HelpItem, {
      helpText: "authentication-help:alias",
      fieldLabelId: "authentication:alias"
    })
  }, /* @__PURE__ */ React.createElement(TextInput, {
    isReadOnly: !!config,
    type: "text",
    id: "alias",
    name: "alias",
    "data-testid": "alias",
    ref: register({required: true}),
    validated: errors.alias ? ValidatedOptions.error : ValidatedOptions.default
  })), configDescription.properties?.map((property) => /* @__PURE__ */ React.createElement(FormGroup, {
    key: property.name,
    label: property.label,
    fieldId: property.name,
    labelIcon: /* @__PURE__ */ React.createElement(HelpItem, {
      helpText: property.helpText,
      fieldLabelId: property.name
    })
  }, /* @__PURE__ */ React.createElement(TextInput, {
    type: "text",
    id: property.name,
    name: property.name,
    ref: register
  }))), /* @__PURE__ */ React.createElement(ActionGroup, null, /* @__PURE__ */ React.createElement(Button, {
    "data-testid": "save",
    variant: "primary",
    type: "submit"
  }, t("common:save")), /* @__PURE__ */ React.createElement(Button, {
    "data-testid": "cancel",
    variant: ButtonVariant.link,
    onClick: () => {
      setShow(false);
    }
  }, t("common:cancel")), config && /* @__PURE__ */ React.createElement(Button, {
    className: "pf-u-ml-4xl",
    "data-testid": "clear",
    variant: ButtonVariant.link,
    onClick: async () => {
      await adminClient.authenticationManagement.delConfig({
        id: config.id
      });
      setConfig(void 0);
      setShow(false);
    }
  }, t("common:clear"), " ", /* @__PURE__ */ React.createElement(TrashIcon, null))))));
};
